import { Button } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type EmailTemplateListErrorStateProps = {
  onRetry: () => void;
};

export const EmailTemplateListErrorState: FC<EmailTemplateListErrorStateProps> = ({ onRetry }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col items-start gap-4 rounded-2xl border border-red-200 bg-red-50 p-6'>
      <div className='space-y-1'>
        <h3 className='text-base font-semibold text-red-800'>{t('emailWorkspace.templates.failedToLoadTemplates')}</h3>
        <p className='text-sm text-red-700'>{t('emailWorkspace.templates.failedToLoadTemplatesDescription')}</p>
      </div>
      <Button intent='secondary' text={t('emailWorkspace.templates.tryAgain')} onClick={onRetry} />
    </div>
  );
};
